import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Query from './Query';
var useStyles = makeStyles(function (theme) {
  return {
    divider: {
      padding: theme.spacing(2, 0)
    },
    title: R.pathOr({}, ['mixins', 'apiQueries', 'title'], theme)
  };
});
var ApiQueries = function ApiQueries(_ref) {
  var _ref$queries = _ref.queries,
    queries = _ref$queries === undefined ? [] : _ref$queries,
    labels = _ref.labels,
    _ref$delay = _ref.delay,
    delay = _ref$delay === undefined ? 1000 : _ref$delay,
    handleClick = _ref.handleClick;
  var classes = useStyles();
  var hasQueries = R.not(R.isEmpty(queries));
  return React.createElement(Grid, {
    container: true,
    'data-testid': 'apiqueries-test-id'
  }, React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Typography, {
    className: classes.title,
    variant: 'h6'
  }, R.prop('title')(labels)), R.map(function (description) {
    return React.createElement(Typography, {
      key: description,
      display: 'block',
      variant: 'body2'
    }, description);
  })(R.propOr([], 'descriptions', labels))), hasQueries && React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.divider
  }, React.createElement(Divider, null)), React.createElement(Grid, {
    item: true,
    container: true,
    spacing: 2
  }, R.map(function (_ref2) {
    var id = _ref2.id,
      title = _ref2.title,
      _ref2$contents = _ref2.contents,
      contents = _ref2$contents === undefined ? [] : _ref2$contents;
    return React.createElement(Query, {
      key: id,
      title: title,
      contents: contents,
      selectedId: R.pipe(R.head, R.prop('id'))(contents),
      labels: labels,
      delay: delay,
      handleClick: handleClick
    });
  })(queries)), hasQueries && React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.divider
  }, React.createElement(Divider, null)), React.createElement(Typography, {
    variant: 'body2'
  }, R.prop('notice')(labels)));
};
ApiQueries.propTypes = process.env.NODE_ENV !== "production" ? {
  labels: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    copy: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    copied: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    descriptions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
    notice: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    buttonsLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  }),
  delay: PropTypes.number,
  queries: PropTypes.arrayOf(PropTypes.shape({
    contents: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      value: PropTypes.string
    })),
    id: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  })),
  handleClick: PropTypes.func
} : {};
export default ApiQueries;